// Modules
import React from 'react';
import {connect} from 'react-redux';
import * as actions from '../actions/user';
import store from '../store';
// Comps & Styling
import Main from './main';
export var appurl = window.location.href;

export class Landing extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            newUser: false,
            submitID: '',
            submitPW: '',
            loginError: null
        };
    }

    loginUser(e){
        let payload = {method: 'GET'};
        console.log(this.state.submitID);
        store.dispatch(actions.loginAsync(this.state.submitID, this.state.submitPW, payload));
    }
    loginDemoAccount(e, user, pass){
        e.preventDefault();

        document.getElementById('js-user').value = user;
        document.getElementById('js-password').value = pass;
        this.setState({
            ...this.state,
            submitID: user,
            submitPW: pass
        })
    }
    createUser(event){
        event.preventDefault();
        let payload = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            method: 'POST',
            body: JSON.stringify({
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                gamertag: this.state.gamertag,
                password: this.state.password,
                email: this.state.email
            }),
        };
        store.dispatch(actions.createAccountAsync(payload));
        this.setState({
            ...this.state,
            newUser: false
        });
    };
    updateUserLocalStateData(event, key){
        this.setState({
            ...this.state,
            [key]: event.target.value});
    }
    toggleNewUser(e){
        if(!this.state.newUser){
            this.setState({newUser: true})
        }
        else{
            this.setState({newUser: false})
        }
    };
    updateColor(e){
        e.target.style.backgroundColor="white"
    }

    render(){
        if(this.props.userLoggedIn){
            return(
                <Main/>
            );
        }
        else if(this.state.newUser===false){
            return(
                <div id="container-landing" className="testName">
                    <div id="form-login" className="menuWrapper">
                        <img id="banner" src="./imgs/logo.svg" alt="Buhl Park Disc Golf"/>
                        <details>
                            <summary>Quickstart!</summary>
                            <div id="getting-started">
                                <div style={{height: "1rem", backgroundColor: "rgb(32, 89, 32)"}}/>
                                <div>
                                    <img src="./imgs/account.svg" alt="Null"/>
                                    <ul>
                                        <li>Create a user account or login by selecting a demo account from below!.</li>
                                        <li>Update or remove your account at anytime.</li>
                                    </ul>
                                </div>
                                <div>
                                    <img src="./imgs/game.svg" alt="Null"/>
                                    <ul>
                                        <li>Create or join an existing match.</li>
                                        <li>View the scorecard from the drop-down located at the top of the page.</li>
                                        <li>Each tee is under its own drop-down, select one to update your score.</li>
                                        <li>Tee scores & scorecards will update automatically across player devices!</li>
                                    </ul>
                                </div>
                                <div>
                                    <img src="./imgs/history.svg" alt="Null"/>
                                    <ul>
                                        <li>Matches are saved automatically when a player leaves a match.</li>
                                        <li>Previous matches are saved under their title, location, & date.</li>
                                        <li>Select a match to view a drop-down which reveals the match roster and scorecard.</li>
                                    </ul>
                                </div>
                            </div>
                        </details>
                        <form >
                            <fieldset>
                                <label>Gamertag:</label><br/>
                                <input id="js-user" type="text" placeholder="gamertag" onFocus={e=>{this.updateColor(e)}} onChange={e=>{this.updateUserLocalStateData(e, 'submitID')}}/>
                                <br/><label>Password:</label><br/>
                                <input id="js-password" type="text" placeholder="Password" onFocus={e=>{this.updateColor(e)}} onChange={e=>{this.updateUserLocalStateData(e, 'submitPW')}}/>
                                <br/>
                                <br/>
                                <input id="js-submitUser" type="button" value="Login" onClick={(e)=>{this.loginUser(e)}} style={{marginTop: "1rem"}} className="btnColoring"/>
                                <input id="js-newUser" type="button" value="Create User" onClick={(e)=>{this.toggleNewUser(e)}} className="btnColoring"/>
                                <h3><a onClick={e=>this.loginDemoAccount(e, 'demo-john', 'abc123')}>Demo account 1</a>    <a onClick={e=>this.loginDemoAccount(e, 'demo-sue', 'abc123')}>Demo Account 2</a></h3>
                            </fieldset>
                        </form>
                    </div>
                </div>
            );
        }
        else if(this.state.newUser===true){
            return(
                <div id="container-landing">
                    <form id="form-create-user" className="menuWrapper">
                        <img id="banner" src="./imgs/logo.svg" alt="Buhl Park Disc Golf"/>
                        <fieldset>
                            <br/><label>First Name:</label><br/>
                            <input id="js-name-first" type="text" placeholder="First" onChange={e=>this.updateUserLocalStateData(e, 'firstName')}/>
                            <br/><label>Last Name:</label><br/>
                            <input id="js-name-last" type="text" placeholder="Last" onChange={e=>this.updateUserLocalStateData(e, 'lastName')}/>
                            <br/><label>Gamertag:</label><br/>
                            <input id="js-gamertag" type="text" placeholder="Gamertag" onChange={e=>this.updateUserLocalStateData(e, 'gamertag')}/>
                            <br/><label>Password:</label><br/>
                            <input id="js-password" type="text" placeholder="Password" onChange={e=>this.updateUserLocalStateData(e, 'password')}/>
                            <br/><label>Email:</label><br/>
                            <input id="js-email" type="text" placeholder="Email" onChange={e=>this.updateUserLocalStateData(e, 'email')}/>
                            <br/>
                            <input id="js-newUser" type="button" value="Create User" onClick={(e)=>{this.createUser(e)}} style={{marginTop: '1rem'}} className="btnColoring"/>
                            <input id="js-newUser" type="button" value="Cancel" onClick={(e)=>{this.toggleNewUser(e)}} className="btnColoring"/>
                        </fieldset>
                    </form>
                </div>
            );
        }
    }
}

const mapPropsToState = state =>({
    userLoggedIn: state.user.userLoggedIn
});

export default connect(mapPropsToState)(Landing)


// WEBPACK FOOTER //
// ./src/comps/landing.js